import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 verify_sales_rep_account: { message: "idle" },
};

export const verify_sales_rep_account_Slice = createSlice({
 name: "verify_sales_rep_account",
 initialState,
 reducers: {
  success_verify_sales_rep_account: (state, action) => {
   state.verify_sales_rep_account = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_verify_sales_rep_account: (state, action) => {
   state.verify_sales_rep_account = { status: app_consts.FAIL, message: action.payload };
  },
  reset_verify_sales_rep_account: (state) => {
   state.verify_sales_rep_account = { status: app_consts.IDLE };
  },
  loading_verify_sales_rep_account: (state) => {
   state.verify_sales_rep_account = { status: app_consts.LOADING };
  },
 }
});

export const { success_verify_sales_rep_account, fail_verify_sales_rep_account, reset_verify_sales_rep_account, loading_verify_sales_rep_account } = verify_sales_rep_account_Slice.actions;

export default verify_sales_rep_account_Slice.reducer;